import {
  Component,
  Input,
  ElementRef,
  ViewChild,
  forwardRef,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlValueAccessor,
  FormsModule,
  ReactiveFormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { IconValuesType } from '../icon/icon.component.types';
import { TypographyComponent } from '../typography';
import { ErrorComponent } from '../error';

@Component({
  selector: 'hyperkit-textarea',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TypographyComponent,
    ErrorComponent,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextAreaComponent),
      multi: true,
    },
  ],
})
export class TextAreaComponent implements ControlValueAccessor, OnInit {
  @ViewChild('textareaElement') textareaElement!: ElementRef<HTMLTextAreaElement>;

  @Input() label?: string;
  @Input() hint?: string;
  @Input() placeholder = '';
  @Input() rightIcon?: IconValuesType;
  @Input() showClear = false;
  @Input() rows = 3;
  @Input() errorMessage = ''; // Ensure it's always a string
  @Input() hasError = false; // Ensure it's always a boolean

  value = '';
  isFocused = false;
  disabled = false;

  private onChange: (value: string) => void = (value: string) => {
    console.warn('onChange function not registered yet.', value);
  };

  private onTouched: () => void = () => {
    console.warn('onTouched function not registered yet.');
  };

  constructor() {}

  ngOnInit(): void {}

  onInput(event: Event): void {
    const value = (event.target as HTMLTextAreaElement).value;
    this.value = value;
    this.onChange(value);
  }

  onCancel(): void {
    if (!this.disabled) {
      this.value = '';
      this.onChange('');
    }
  }

  onFocus(): void {
    this.isFocused = true;
    this.onTouched();
  }

  clearText(): void {
    if (!this.disabled) {
      this.value = '';
      this.onChange('');
    }
  }

  onBlur(): void {
    this.isFocused = false;
    this.onTouched();
  }

  // ControlValueAccessor implementation
  writeValue(value: string | null): void {
    this.value = value ?? '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
